<template>
  <div>
    <!-- Form -->
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap> 
								<v-flex xs12 sm6 md6>
								<v-text-field
                  label="Sector Name *"
                  v-model="formSchema.sector_name" 
									:rules="[v => !!v || 'Sector name is required !', lng200]"
	                required>	
                ></v-text-field>
								</v-flex>

								<v-flex xs12 sm6 md6>
								<v-text-field
                  label="Sector Short Name"
                  v-model="formSchema.short_name" 
								>	
                ></v-text-field>
								</v-flex>

								<v-flex xs12 sm6 md6>
                  <v-checkbox v-model="formSchema.is_active" label="Active" :value="isActiveVal"></v-checkbox>
                </v-flex>
                            
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click.native="validateBeforeSubmit" :disabled="!valid">
            <v-icon>save</v-icon>
            {{addUpdateBtn}}
          </v-btn>
          <v-btn color="error" @click.native="reset">
            <v-icon>refresh</v-icon>Reset
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <!-- /Form -->
  </div>
</template>


<script>
let commonService = require("../../../../services/common.service"); 

export default {
  props: ["formSchema"], 
  
  data: () => ({
    valid: true,
    isActiveVal: 1,     
  }),

  computed: {
    formTitle() {
      return this.formSchema.id > 0
        ? "Edit Sector"
        : "Add Sector";
    },
    addUpdateBtn() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    }
  },
  /*
  created() {    
    commonService.getAllData("api-url-here").then(res => {
      this.put_arraName = res;
    });
  },*/

  methods: { 
    
    validateBeforeSubmit(e) {
      if (this.$refs.form.validate()) {
        this.submitForm();
      }
    },

    submitForm() {
      var formSchema = this.formSchema;       

      if (formSchema.id > 0) {
        commonService
          .updateFormData(formSchema, "sector")
          .then(res => {
            let actionData = {
              message: res.message,
              data: res.data,
              action: "edit",
              status: res.status
            };
            this.close(actionData);
          });
      } else {
        commonService
          .insertFormData(formSchema, "sector")
          .then(res => {
            let actionData = {
              message: res.message,
              data: res.data,
              action: "add",
              status: res.status
            };
            this.close(actionData);
          });
      }
    },

    close: function(data) {
      if(data.status==1)
      {
        this.$refs.form.reset();
        this.formSchema.id = 0;
      }                      
      this.$emit("emitForm", data);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/lending/sector/sector/insertForm.vue